import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d17e957")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "custom-textarea",
    ref: "textareaRef",
    contenteditable: _ctx.contenteditable,
    onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
    onInput: _cache[3] || (_cache[3] = $event => _ctx.handleInput($event)),
    innerHTML: _ctx.text
  }, null, 40, ["contenteditable", "innerHTML"]))
})